var _style, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSoundwaves = function SvgSoundwaves(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n.bar {\n  transform-box: fill-box;\n  transform-origin: center;\n  vector-effect: non-scaling-stroke;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  overflow: visible;\n  will-change: transform;\n  shape-rendering: geometricPrecision;\n}\n@keyframes sound-wave-1 {\n  0% { transform: scaleY(0.7083); }\n  16.666667% { transform: scaleY(1.3333); }\n  33.333333% { transform: scaleY(0.9167); }\n  50% { transform: scaleY(1.75); }\n  66.666667% { transform: scaleY(1.125); }\n  83.333333% { transform: scaleY(1.5417); }\n  100% { transform: scaleY(0.7083); }\n}\n.bar-1 { animation: sound-wave-1 1.6s linear infinite; }\n@keyframes sound-wave-2 {\n  0% { transform: scaleY(0.5139); }\n  20% { transform: scaleY(0.2361); }\n  40% { transform: scaleY(0.7222); }\n  60% { transform: scaleY(0.375); }\n  80% { transform: scaleY(0.9306); }\n  100% { transform: scaleY(0.5139); }\n}\n.bar-2 { animation: sound-wave-2 1.8s linear infinite; }\n@keyframes sound-wave-3 {\n  0% { transform: scaleY(0.75); }\n  20% { transform: scaleY(1.5833); }\n  40% { transform: scaleY(1.1667); }\n  60% { transform: scaleY(0.3333); }\n  80% { transform: scaleY(1.3056); }\n  100% { transform: scaleY(0.75); }\n}\n.bar-3 { animation: sound-wave-3 1.5s linear infinite; }\n@keyframes sound-wave-4 {\n  0% { transform: scaleY(0.7222); }\n  20% { transform: scaleY(0.3056); }\n  40% { transform: scaleY(0.5139); }\n  60% { transform: scaleY(1.0); }\n  80% { transform: scaleY(0.4444); }\n  100% { transform: scaleY(0.7222); }\n}\n.bar-4 { animation: sound-wave-4 1.7s linear infinite; }\n@keyframes sound-wave-5 {\n  0% { transform: scaleY(0.6667); }\n  16.666667% { transform: scaleY(0.7708); }\n  33.333333% { transform: scaleY(0.3542); }\n  50% { transform: scaleY(0.875); }\n  66.666667% { transform: scaleY(0.4583); }\n  83.333333% { transform: scaleY(0.6667); }\n  100% { transform: scaleY(0.6667); }\n}\n.bar-5 { animation: sound-wave-5 1.9s linear infinite; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6V10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    className: "bar bar-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2V14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    className: "bar bar-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5V11",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    className: "bar bar-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2V14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    className: "bar bar-4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4V12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    className: "bar bar-5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSoundwaves);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/soundwaves.bf4a6ea77366318c509161a196e7035a.svg";